<mat-expansion-panel [expanded]="!!(contact.isPrimary)" class="mat-elevation-z0 business-personnel">
  <mat-expansion-panel-header>
    <mat-panel-title class="tw-mt-4">
      {{ contact.first }} {{ contact.last }}
      <mat-chip-list class="contact-ownership">
        <mat-chip *ngIf="contact.percentOwnership; else noOwnership" class="contact-ownership-chip">{{ contact.percentOwnership }}%</mat-chip>
        <ng-template #noOwnership>
          <mat-chip class="contact-ownership-chip">0%</mat-chip>
        </ng-template>
      </mat-chip-list>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div *ngFor="let element of contactElements; last as last">
    <div class="content-item-container">
      <p class="mb-0">{{ element.label }}</p>
      <p class="value">
        <span class="extra-label" *ngIf="element.extraLabel">{{ element.extraLabel }}</span>
        <span [ngSwitch]="element.pipe">
          <span *ngSwitchCase="'date'">{{ element.value | date  }}</span>
          <span *ngSwitchCase="'ssn'">{{ element.value | ssn }}</span>
          <span *ngSwitchCase="'phone'">+{{ element.phoneCountryCode }} {{ element.value | phone: element.country }}</span>
          <span *ngSwitchDefault>{{ element.value }}</span>
        </span>
      </p>
    </div>
    <mat-divider *ngIf="!last"></mat-divider>
  </div>
</mat-expansion-panel>
